module.exports = __webpack_public_path__ + "static/media/r1.0b08b429.png";